export class CompanyKey {
  private value: string;

  setCompanyKey(value: string): void {
    this.value = value;
  }

  getCompanyKey(): {} {
    return this.value;
  }
}
